<template>
  <viewer>
    <img class="img-fluid" :src="img">
  </viewer>
</template>

<script>
  export default {
    name: 'BigImgViwer',
    props: {
    },
    data(){
      return{
        img:"",
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/BigImgViwer.vue